module.exports = __webpack_public_path__ + "media/images/redesign-images/corporate/business-share-image-17882b77cfe3e813494a62788997274d.jpg";